import { render } from "./BaseField.vue?vue&type=template&id=4b77c468&scoped=true&ts=true"
import script from "./BaseField.vue?vue&type=script&lang=ts"
export * from "./BaseField.vue?vue&type=script&lang=ts"

import "./BaseField.vue?vue&type=style&index=0&id=4b77c468&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b77c468"]])

export default __exports__